import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, SendIcon } from 'lucide-react';
export const ContactPage = () => {
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-358">
      <div className="container mx-auto px-4 py-8" data-id="element-359">
        <h1 className="text-3xl font-bold mb-8" data-id="element-360">Contact Us</h1>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-361">
          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-362">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-363">
              <div className="p-6" data-id="element-364">
                <h2 className="text-xl font-bold mb-6" data-id="element-365">Send Us a Message</h2>
                <form data-id="element-366">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-367">
                    <div data-id="element-368">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-369">
                        First Name
                      </label>
                      <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-370" />
                    </div>
                    <div data-id="element-371">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-372">
                        Last Name
                      </label>
                      <input type="text" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-373" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-374">
                    <div data-id="element-375">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-376">
                        Email Address
                      </label>
                      <input type="email" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-377" />
                    </div>
                    <div data-id="element-378">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-379">
                        Phone Number
                      </label>
                      <input type="tel" className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-380" />
                    </div>
                  </div>
                  <div className="mb-4" data-id="element-381">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-382">
                      Subject
                    </label>
                    <select className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-383">
                      <option value="" data-id="element-384">Select a subject</option>
                      <option value="order" data-id="element-385">Order Inquiry</option>
                      <option value="product" data-id="element-386">Product Information</option>
                      <option value="return" data-id="element-387">Return or Refund</option>
                      <option value="other" data-id="element-388">Other</option>
                    </select>
                  </div>
                  <div className="mb-6" data-id="element-389">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-390">
                      Message
                    </label>
                    <textarea className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent h-32" placeholder="How can we help you?" data-id="element-391"></textarea>
                  </div>
                  <button type="submit" className="bg-green-500 text-white py-3 px-6 rounded-lg hover:bg-green-600 transition-colors flex items-center" data-id="element-392">
                    <SendIcon size={16} className="mr-2" data-id="element-393" />
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
          {/* Contact Information */}
          <div data-id="element-394">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6" data-id="element-395">
              <div className="p-6" data-id="element-396">
                <h2 className="text-xl font-bold mb-6" data-id="element-397">Contact Information</h2>
                <div className="space-y-4" data-id="element-398">
                  <div className="flex" data-id="element-399">
                    <div className="flex-shrink-0" data-id="element-400">
                      <div className="bg-green-50 rounded-full h-10 w-10 flex items-center justify-center" data-id="element-401">
                        <PhoneIcon size={20} className="text-green-500" data-id="element-402" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-403">
                      <h3 className="text-sm font-medium text-gray-500" data-id="element-404">
                        Phone
                      </h3>
                      <p className="text-gray-700" data-id="element-405">(555) 123-4567</p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-406">
                    <div className="flex-shrink-0" data-id="element-407">
                      <div className="bg-green-50 rounded-full h-10 w-10 flex items-center justify-center" data-id="element-408">
                        <MailIcon size={20} className="text-green-500" data-id="element-409" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-410">
                      <h3 className="text-sm font-medium text-gray-500" data-id="element-411">
                        Email
                      </h3>
                      <p className="text-gray-700" data-id="element-412">support@techgold.com</p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-413">
                    <div className="flex-shrink-0" data-id="element-414">
                      <div className="bg-green-50 rounded-full h-10 w-10 flex items-center justify-center" data-id="element-415">
                        <MapPinIcon size={20} className="text-green-500" data-id="element-416" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-417">
                      <h3 className="text-sm font-medium text-gray-500" data-id="element-418">
                        Address
                      </h3>
                      <p className="text-gray-700" data-id="element-419">123 Market Street</p>
                      <p className="text-gray-700" data-id="element-420">San Francisco, CA 94105</p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-421">
                    <div className="flex-shrink-0" data-id="element-422">
                      <div className="bg-green-50 rounded-full h-10 w-10 flex items-center justify-center" data-id="element-423">
                        <ClockIcon size={20} className="text-green-500" data-id="element-424" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-425">
                      <h3 className="text-sm font-medium text-gray-500" data-id="element-426">
                        Business Hours
                      </h3>
                      <p className="text-gray-700" data-id="element-427">
                        Monday - Friday: 9am - 6pm
                      </p>
                      <p className="text-gray-700" data-id="element-428">Saturday: 10am - 4pm</p>
                      <p className="text-gray-700" data-id="element-429">Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-430">
              <div className="p-6" data-id="element-431">
                <h2 className="text-xl font-bold mb-6" data-id="element-432">
                  Frequently Asked Questions
                </h2>
                <div className="space-y-4" data-id="element-433">
                  <div data-id="element-434">
                    <h3 className="font-medium mb-1" data-id="element-435">
                      How do you ensure product quality?
                    </h3>
                    <p className="text-gray-600 text-sm" data-id="element-436">
                      All our electronics undergo a rigorous 27-point inspection
                      process, and our precious metals are authenticated for
                      purity.
                    </p>
                  </div>
                  <div data-id="element-437">
                    <h3 className="font-medium mb-1" data-id="element-438">
                      What is your return policy?
                    </h3>
                    <p className="text-gray-600 text-sm" data-id="element-439">
                      We offer a 30-day return policy on all products. Items
                      must be returned in the same condition they were received.
                    </p>
                  </div>
                  <div data-id="element-440">
                    <h3 className="font-medium mb-1" data-id="element-441">
                      Do you offer international shipping?
                    </h3>
                    <p className="text-gray-600 text-sm" data-id="element-442">
                      Yes, we ship to select international destinations.
                      Shipping costs and delivery times vary by location.
                    </p>
                  </div>
                  <div data-id="element-443">
                    <h3 className="font-medium mb-1" data-id="element-444">
                      How do you grade refurbished electronics?
                    </h3>
                    <p className="text-gray-600 text-sm" data-id="element-445">
                      We use a standard grading system: Like New, Excellent,
                      Good, and Fair. Each listing includes detailed condition
                      information.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};